import { render, staticRenderFns } from "./PopOverSearch.vue?vue&type=template&id=610948a6&scoped=true&"
import script from "./PopOverSearch.vue?vue&type=script&lang=js&"
export * from "./PopOverSearch.vue?vue&type=script&lang=js&"
import style0 from "./PopOverSearch.vue?vue&type=style&index=0&id=610948a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610948a6",
  null
  
)

export default component.exports